import { useInfiniteQuery } from "@tanstack/react-query";

import axiosInstance from "@/api/axiosInstance";

export type NotifyApiResponse = {
  results: NotifyType[];
  totalCount: number;
  page: number;
  totalPage: number;
  pageSize: number;
  hasNextPage: string;
};

export type NotifyType = {
  id: string;
  title: string;
  params: string;
  content: string;
  link: string;
  createdAt: string;
  isRead: boolean;
  notificationType:
  | "OPEN_CONSTRUCTION"
  | "POLYGON"
};

const getNotificationList = async (page: number = 1, category?: string, size = 10) => {
  const response = await axiosInstance.get("/api/v1/admin/notifications", {
    params: { page, category, size },
  });
  return response.data.data;
};

export const useGetNotificationList = (category?: string, size = 10) => {
  return useInfiniteQuery<NotifyApiResponse>({
    queryKey: ["notifications", category, size],
    queryFn: ({ pageParam = 1 }) => getNotificationList(pageParam as number, category, size),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.hasNextPage === "Y" ? lastPage.page + 1 : undefined;
    },
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });
};
